import { useContext } from "react";
import FeatureFlagContext from "./FeatureFlagContext";

function useFeatureFlag() {
    const context = useContext(FeatureFlagContext);
    if (!context) {
        throw Error("No FeatureFlag Context!");
    }

    return context;
}

export default useFeatureFlag;
